/**
 * Interruptores maestros de funciones (sep-2026). `GET /api/features` es público: lo apagado no se
 * renderiza (tiles, botones, rutas). Default OFF hasta que llegue la respuesta, para no parpadear.
 */
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '@/lib/api';

const DEFAULT_FLAGS = { work_requests: false };
const FeatureFlagsContext = createContext({ flags: DEFAULT_FLAGS, loaded: false, refresh: () => {} });

export const FeatureFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState(DEFAULT_FLAGS);
  const [loaded, setLoaded] = useState(false);
  const refresh = useCallback(() => api.get('/features')
    .then((d) => setFlags({ ...DEFAULT_FLAGS, ...(d || {}) }))
    .catch(() => {})
    .finally(() => setLoaded(true)), []);
  useEffect(() => { refresh(); }, [refresh]);
  const value = useMemo(() => ({ flags, loaded, refresh }), [flags, loaded, refresh]);
  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>;
};

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
export const useFeature = (key) => Boolean(useContext(FeatureFlagsContext).flags[key]);
